module.exports = __webpack_public_path__ + "img/1-3.2e5603ff.png";